export default __webpack_public_path__ + "static/hero.dark-de97b6c367974a9b99d3d04f49db2c1e101f088c73c855709214cc868af3d8c6.png";